module.exports = __webpack_public_path__ + "static/img/map.cde6f75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map.jpg
// module id = aZiJ
// module chunks = 1